import React from 'react'

function AboutBannerComponent() {
    return (
        <div className='innerpage-banner'>
            <div className={`container mainComponentCenter d-flex flex-column justify-content-center align-items-center  mt-lg-0`} >
            <h1 className='text-light nav-item-main-head '> Best Mehandi Artist In Malappuram kerala</h1>
        </div>
        </div>
    )
}

export default AboutBannerComponent